import React, { useEffect, useState, useContext } from 'react';
import { Grid, FormLabel, FormHelperText, CircularProgress, Typography } from '@material-ui/core';
import { CustomColorPicker, SecondaryButton, TextBox, YesNoButton, SingelSelect, SelectBox } from '../../../../Core/FormInput';
import AppContext from './../../../../App/AppContext';
import { getTCardWorkTypesByID, postTCardWorkTypes, fetchWorkTypeDropdown } from '../../../../Core/Service/TCard-WorkTypes-service';
import { SketchPicker } from 'react-color';

const AddUpdateWorkTypes = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        tCardWorkTypeDisplayTimer: false,
        tCardWorkTypeDescription: '',
        tCardWorkTypeCause: '',
        tCardWorkTypeCure: '',
        tCardWorkTypeSequence: '',
        tCardWorkTypeAllocatedHours: '',
        tCardWorkTypeEventID: '',
        tcardWorkTypeTextColour: '#000000',
        tcardWorkTypeBackColour: '#ffffff',
        dropdownOptions: [],
        errors: {}
    });

    useEffect(() => {
        const fetchWorkTypes = async () => {
            if (props.workTypeID) {
                setLoading(true);
                try {
                    let res = await getTCardWorkTypesByID(props.workTypeID);
                    let data = res?.data?.list?.table[0] || {};
                    if (res.success) {
                        setState((st) => ({
                            ...st,
                            tCardWorkTypeDescription: data.tCardWorkTypeDescription,
                            tCardWorkTypeCause: data.tCardWorkTypeCause,
                            tCardWorkTypeCure: data.tCardWorkTypeCure,
                            tCardWorkTypeAllocatedHours: data.tCardWorkTypeAllocatedHours,
                            tCardWorkTypeSequence: data.tCardWorkTypeSequence,
                            tCardWorkTypeDisplayTimer: data.tCardWorkTypeDisplayTimer,
                            tcardWorkTypeTextColour: data.tcardWorkTypeTextColour || '#000000',
                            tcardWorkTypeBackColour: data.tcardWorkTypeBackColour || '#ffffff',
                            tCardWorkTypeEventID: data.tCardWorkTypeEventID || '',
                            errors: {}
                        }));
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchWorkTypes();
    }, [props.workTypeID]);

    useEffect(() => {
        const fetchDropdownData = async () => {
            let dropDownRes = await fetchWorkTypeDropdown();
            if (dropDownRes.success) {
                setState((st) => ({
                    ...st,
                    dropdownOptions: dropDownRes.data?.list?.table
                }));
            }
        };
        fetchDropdownData();
    }, []);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value,
            errors: { ...st.errors, [name]: '' }
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.tCardWorkTypeDescription.trim()) {
            formIsValid = false;
            errors.tCardWorkTypeDescription = 'Description is required.';
        }
        if (state.tCardWorkTypeCause === '') {
            formIsValid = false;
            errors.tCardEventTypeCause = 'Cause is required.';
        }
        if (state.tCardWorkTypeCure === '') {
            formIsValid = false;
            errors.tCardEventTypeCure = 'Cure is required.';
        }
        if (state.tCardWorkTypeAllocatedHours === '') {
            formIsValid = false;
            errors.tCardWorkTypeAllocatedHours = 'Allocated Hours is required.';
        } else {
            const allocatedHours = parseFloat(state.tCardWorkTypeAllocatedHours);
            if (isNaN(allocatedHours)) {
                formIsValid = false;
                errors.tCardWorkTypeAllocatedHours = 'Please enter a valid decimal for Allocated Hours.';
            }
        }
        if (state.tCardWorkTypeSequence === '') {
            formIsValid = false;
            errors.tCardWorkTypeSequence = 'Sequence is required.';
        } else {
            const sequence = parseInt(state.tCardWorkTypeSequence, 10);
            if (isNaN(sequence)) {
                formIsValid = false;
                errors.tCardWorkTypeSequence = 'Please enter a valid integer for Sequence.';
            } else if (sequence < 0 || sequence > 32767) {
                formIsValid = false;
                errors.tCardWorkTypeSequence = 'Sequence must be between 0 and 32767.';
            }
        }
        if (!state.tCardWorkTypeEventID) {
            formIsValid = false;
            errors.tCardWorkTypeEventID = 'Event Type is required.';
        }
        setState((st) => ({
            ...st,
            errors: errors
        }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setLoading(true);
            try {
                const data = {
                    tCardWorkTypeID: props.workTypeID || null,
                    tCardWorkTypeDescription: state.tCardWorkTypeDescription,
                    tCardWorkTypeCause: state.tCardWorkTypeCause,
                    tCardWorkTypeCure: state.tCardWorkTypeCure,
                    tCardWorkTypeAllocatedHours: state.tCardWorkTypeAllocatedHours,
                    tCardWorkTypeSequence: state.tCardWorkTypeSequence,
                    tCardWorkTypeEventID: state.tCardWorkTypeEventID,
                    tCardWorkTypeDisplayTimer: state.tCardWorkTypeDisplayTimer,
                    tcardWorkTypeTextColour: state.tcardWorkTypeTextColour,
                    tcardWorkTypeBackColour: state.tcardWorkTypeBackColour
                };
                let res = await postTCardWorkTypes(data);
                if (res.data.success) {
                    showToast(`Work Type ${props.workTypeID ? 'Updated' : 'Added'} successfully`);
                    props.onClose(true);
                } else {
                    console.error(res.message);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div>
            {loading ? (
                <div style={{ margin: '268px 440px' }}>
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold' }}>Loading...</Typography>
                </div>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormLabel className="mandatoryfields">Description*</FormLabel>
                        <TextBox onChange={handleInput} autoFocus value={state.tCardWorkTypeDescription} name="tCardWorkTypeDescription" />
                        {state.errors.tCardWorkTypeDescription && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardWorkTypeDescription}</FormHelperText>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel className="mandatoryfields">Cause*</FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardWorkTypeCause} name="tCardWorkTypeCause" />
                        {state.errors.tCardWorkTypeCause && <FormHelperText className="mandatoryfields">{state.errors.tCardWorkTypeCause}</FormHelperText>}
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel className="mandatoryfields">Cure*</FormLabel>
                        <TextBox onChange={handleInput} value={state.tCardWorkTypeCure} name="tCardWorkTypeCure" />
                        {state.errors.tCardWorkTypeCure && <FormHelperText className="mandatoryfields">{state.errors.tCardWorkTypeCure}</FormHelperText>}
                    </Grid>
                    <Grid item xs={12} container spacing={3}>
                        <Grid item xs={12} sm={6} style={{ marginRight: 10 }}>
                            <FormLabel style={{ marginBottom: 5 }}>
                                <b>Text Colour</b>
                            </FormLabel>
                            <CustomColorPicker
                                color={state.tcardWorkTypeTextColour}
                                onChange={(color) => setState((st) => ({ ...st, tcardWorkTypeTextColour: color.hex }))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ marginRight: -10 }}>
                            <FormLabel style={{ marginBottom: 5 }}>
                                <b>Background Colour</b>
                            </FormLabel>
                            <CustomColorPicker
                                color={state.tcardWorkTypeBackColour}
                                onChange={(color) => setState((st) => ({ ...st, tcardWorkTypeBackColour: color.hex }))}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel className="mandatoryfields">Allocated Hours*</FormLabel>
                        <TextBox
                            onChange={handleInput}
                            type="number"
                            value={state.tCardWorkTypeAllocatedHours}
                            name="tCardWorkTypeAllocatedHours"
                            inputProps={{
                                style: {
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'textfield'
                                }
                            }}
                        />
                        {state.errors.tCardWorkTypeAllocatedHours && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardWorkTypeAllocatedHours}</FormHelperText>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel className="mandatoryfields" style={{ marginBottom: 2 }}>
                            Display Sequence*
                        </FormLabel>
                        <TextBox
                            onChange={handleInput}
                            type="number"
                            value={state.tCardWorkTypeSequence}
                            name="tCardWorkTypeSequence"
                            inputProps={{
                                style: {
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'textfield'
                                },
                                pattern: '[0-9]*'
                            }}
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                        />
                        {state.errors.tCardWorkTypeSequence && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardWorkTypeSequence}</FormHelperText>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel className="mandatoryfields">Event Type*</FormLabel>
                        <SelectBox
                            onChange={handleInput}
                            value={state.tCardWorkTypeEventID}
                            name="tCardWorkTypeEventID"
                            List={state.dropdownOptions || []}
                            style={{ marginTop: 9, textAlign: 'left' }}
                        />
                        {state.errors.tCardWorkTypeEventID && <FormHelperText className="mandatoryfields">{state.errors.tCardWorkTypeEventID}</FormHelperText>}
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormLabel className="mandatoryfields" style={{ marginBottom: -5 }}>
                            Display Timer?*
                        </FormLabel>
                        <YesNoButton
                            state={state.tCardWorkTypeDisplayTimer}
                            name="tCardWorkTypeDisplayTimer"
                            onYesClick={() => setState((st) => ({ ...st, tCardWorkTypeDisplayTimer: true }))}
                            onNoClick={() => setState((st) => ({ ...st, tCardWorkTypeDisplayTimer: false }))}
                        />
                    </Grid>

                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                        <SecondaryButton fullWidth onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default AddUpdateWorkTypes;
